import { render, staticRenderFns } from "./OpportunityDashboardOwnersTable.vue?vue&type=template&id=7238f3f3&scoped=true&"
import script from "./OpportunityDashboardOwnersTable.vue?vue&type=script&lang=js&"
export * from "./OpportunityDashboardOwnersTable.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityDashboardOwnersTable.vue?vue&type=style&index=0&id=7238f3f3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7238f3f3",
  null
  
)

export default component.exports